// extracted by mini-css-extract-plugin
export var centerText = "_eu-8";
export var container = "_eu-0";
export var doughnutContainer = "_eu-7";
export var legend = "_eu-a";
export var legendItemColorDisplay = "_eu-b";
export var legendItemLabel = "_eu-d";
export var legendItemValue = "_eu-c";
export var lg = "_eu-5";
export var maxWidth = "_eu-9";
export var md = "_eu-4";
export var responsive = "_eu-6";
export var sm = "_eu-3";
export var xs = "_eu-2";
export var xxs = "_eu-1";